const ThirdPartyAppScript = function() {
    function ThirdPartyAppScript() {
        this.load()
    }
    ThirdPartyAppScript.prototype.load = function() {
        var _ = this;
        let loaded = false;
        window.addEventListener("scroll", function() {
            if(window.scrollY > 10 && !loaded) {
                let chatscript = this.document.createElement("script");
                chatscript.id = 'gorgias-chat-widget-install-v3';
                chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
                document.body.append(chatscript);
                let stampedscript = document.createElement("script");
                stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
                document.body.append(stampedscript);
                let klaviyoscript = document.createElement("script");
                klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
                document.body.append(klaviyoscript);
                loaded = true;
            }
        })
        window.addEventListener("mousemove", function() {
            if(window.scrollY > 10 && !loaded) {
                let chatscript = this.document.createElement("script");
                chatscript.id = 'gorgias-chat-widget-install-v3';
                chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
                document.body.append(chatscript);
                let stampedscript = document.createElement("script");
                stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
                document.body.append(stampedscript);
                let klaviyoscript = document.createElement("script");
                klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
                document.body.append(klaviyoscript);
                loaded = true;
            }
        })
        window.addEventListener("touchstart", function() {
            if(window.scrollY > 10 && !loaded) {
                let chatscript = this.document.createElement("script");
                chatscript.id = 'gorgias-chat-widget-install-v3';
                chatscript.src = "https://config.gorgias.chat/bundle-loader/01GYCCQ5PC3MSBB0CBXZ38Z5HR?source=shopify1click";
                document.body.append(chatscript);
                let stampedscript = document.createElement("script");
                stampedscript.src = "https://cdn1.stamped.io/files/widget.min.js?shop=kiva-wellness.myshopify.com";
                document.body.append(stampedscript);
                let klaviyoscript = document.createElement("script");
                klaviyoscript.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RstYp2";
                document.body.append(klaviyoscript);    
                loaded = true;
            }
        })
    }
    ThirdPartyAppScript = new ThirdPartyAppScript;
}
ThirdPartyAppScript();